import {Observable} from 'rxjs'
import {ACTION_USER_LOGGED_OUT} from '../constants'

export default (errorActionName) => {

  return (data) => {

    const logOutAction = {
      type: ACTION_USER_LOGGED_OUT
    }

    const errorAction = {
      type: errorActionName,
      payload: {
        status: data.status,
        message: data.message,
        xhr:{
          response:op.get(data, `xhr.response`)
        }
      }
    }
    const action = data.status === 401?logOutAction : errorAction
    return Observable.of(action)
  }
}



// WEBPACK FOOTER //
// ./src/epics/errorHandlerBuilder.js